// src/TermsPage.jsx
import React from "react";
import { CURRENT_TERMS_VERSION, CURRENT_TERMS_EFFECTIVE } from "./termsConfig";

const wrap = {
  minHeight: "100dvh",
  display: "grid",
  placeItems: "start center",
  background:
    "radial-gradient(1200px 600px at 10% -20%, rgba(0,176,116,0.04), transparent 50%), radial-gradient(800px 400px at 110% 120%, rgba(244,197,66,0.04), transparent 40%), #f8faf9",
  padding: 24
};
const card = {
  width: "100%",
  maxWidth: 880,
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  padding: 24
};
const h1 = { margin: 0 };
const meta = { color: "#667085", marginTop: 6, fontSize: 13 };
const h2 = { marginTop: 24 };
const p  = { color: "#444", lineHeight: 1.6 };

export default function TermsPage() {
  return (
    <div style={wrap}>
      <article style={card}>
        <h1 style={h1}>Trelli Terms &amp; Conditions</h1>
        <div style={meta}>
          Version {CURRENT_TERMS_VERSION} • Effective {new Date(CURRENT_TERMS_EFFECTIVE).toLocaleDateString()}
        </div>

        {/* —— Paste of the finalized Terms (shortened headings for brevity) —— */}
        <section>
          <h2 style={h2}>1) Overview</h2>
          <p style={p}>
            These Terms & Conditions (“Terms”) are a legal agreement between you and Trelli LLC
            (“Trelli,” “we,” “us,” or “our”) governing your access to and use of Trelli’s websites,
            applications, and related services (the “Services”). By creating an account or using the
            Services, you agree to these Terms. If you do not agree, do not use the Services.
          </p>
          <p style={p}>
            Product-specific terms may apply to certain features or programs (e.g., identity verification,
            debit/credit, virtual cards, rewards). If there is a conflict with these Terms, the product-specific
            terms control for that product.
          </p>
        </section>

        <h2 style={h2}>2) Eligibility &amp; Use</h2>
        <p style={p}>
          Age 18+ and able to enter contracts; head of household may add limited-access family profiles; U.S. use; no use where prohibited by law/sanctions.
        </p>

        <h2 style={h2}>3) Account Registration &amp; Security</h2>
        <p style={p}>
          Keep your info current; you’re responsible for all account activity. 2FA may be required.
        </p>

        <h2 style={h2}>4) Plans: Beta, Free, Standard, Family</h2>
        <p style={p}>
          Beta (free, AS IS); Free (manual); Standard (paid); Family (paid). Your current plan level is
          determined by your account settings and billing status. If you change plans, the new plan’s terms
          apply from the effective date of the change. Plan features may change with notice (§18).
        </p>

        <h2 style={h2}>5) Bank Connections &amp; Third-Party Services</h2>
        <p style={p}>
          If you connect accounts, you authorize Trelli and providers (e.g., Plaid) to access and use data to
          operate the Services, consistent with our Privacy Policy. Availability and accuracy depend on your
          institutions and providers.
        </p>

        <h2 style={h2}>6) KYC/AML; Identity &amp; Fraud Prevention</h2>
        <p style={p}>
          Some features require identity verification with Trelli or our bank/BaaS partners under KYC/AML laws.
        </p>

        <h2 style={h2}>7) Budgeting, Alerts &amp; Declines (Future Capabilities)</h2>
        <p style={p}>
          Tools are best-effort; you remain responsible for your spending and obligations. Trelli is not a bank,
          advisor, or fiduciary.
        </p>

        <h2 style={h2}>8) Family Accounts; Roles &amp; Permissions</h2>
        <p style={p}>Head of household is responsible for all linked profiles and activity.</p>

        <h2 style={h2}>9) Acceptable Use</h2>
        <p style={p}>No unlawful/abusive use; no security circumvention; no rights infringement; no false info.</p>

        <h2 style={h2}>10) Subscriptions, Billing &amp; Trials</h2>
        <p style={p}>Recurring billing until canceled; renewals; price changes with notice; taxes; refunds limited.</p>

        <h2 style={h2}>11) Electronic Communications &amp; E-Sign Consent</h2>
        <p style={p}>You consent to electronic disclosures and signatures.</p>

        <h2 style={h2}>12) No Financial, Legal, or Tax Advice</h2>
        <p style={p}>Information only; you are responsible for decisions.</p>

        <h2 style={h2}>13) Privacy</h2>
        <p style={p}>Use is subject to the Trelli Privacy Policy.</p>

        <h2 style={h2}>14) Intellectual Property; Feedback</h2>
        <p style={p}>Trelli owns/ licenses the Services; feedback may be used without restriction.</p>

        <h2 style={h2}>15) User Content</h2>
        <p style={p}>You represent rights to content you input; license to operate/improve the Services.</p>

        <h2 style={h2}>16) Service Changes; Availability</h2>
        <p style={p}>We may change or discontinue features; occasional unavailability.</p>

        <h2 style={h2}>16A) Third-Party Infrastructure &amp; Providers</h2>
        <p style={p}>
          The Services rely on third-party infrastructure/providers (hosting, cloud, auth, comms, identity,
          data aggregation). To the maximum extent permitted by law, Trelli is not responsible for any
          unavailability, security incident, data loss, corruption, or delay caused by such third parties,
          except to the extent directly caused by Trelli’s failure to use commercially reasonable safeguards
          within Trelli’s control. Your sole remedy for issues attributable to a third party is against that
          third party.
        </p>

        <h2 style={h2}>17) Suspension &amp; Termination</h2>
        <p style={p}>We may suspend/terminate for violations, risk, or legal reasons; you may close your account.</p>

        <h2 style={h2}>18) Changes to These Terms</h2>
        <p style={p}>We may update with notice; continued use after the effective date is acceptance.</p>

        <h2 style={h2}>18A) Versioning &amp; Acceptance Records</h2>
        <p style={p}>
          Trelli may maintain records of your acceptance (version/date). The current version and effective date
          are shown on this page.
        </p>

        <h2 style={h2}>19) Warranties &amp; Disclaimers</h2>
        <p style={p}>
          The Services are provided “AS IS” and “AS AVAILABLE.” Without limiting the foregoing, Trelli does not
          control and is not responsible for the performance, security, or accuracy of third-party services or
          your financial institutions. For Beta, these disclaimers are emphasized.
        </p>

        <h2 style={h2}>20) Limitation of Liability</h2>
        <p style={p}>
          To the maximum extent permitted, Trelli’s total liability will not exceed the greater of $100 or the
          amount you paid to Trelli in the 12 months prior to the event.
        </p>

        <h2 style={h2}>21) Dispute Resolution; Arbitration; Class Waiver</h2>
        <p style={p}>
          Informal resolution; then binding AAA arbitration on an individual basis near Fulton County, Georgia,
          unless agreed otherwise; class action waiver; 30-day opt-out.
        </p>

        <h2 style={h2}>22) Governing Law &amp; Venue</h2>
        <p style={p}>Georgia law; exclusive courts in Fulton County, GA (subject to §21).</p>

        <h2 style={h2}>23) Contact</h2>
        <p style={p}>
          Trelli LLC<br/>
          476 Old Hickory Rd<br/>
          Woodstock, GA 30188<br/>
          Email: Hello@usetrelli.com
        </p>

        <h2 style={h2}>24) Export Controls &amp; Sanctions</h2>
        <p style={p}>No use if embargoed or on restricted lists.</p>

        <h2 style={h2}>25) Miscellaneous</h2>
        <p style={p}>
          Entire agreement; severability; assignment; no implied waivers.
        </p>
      </article>
    </div>
  );
}